/**
 * Admin API types for brand-level Gift Promotions (gift-with-purchase).
 *
 * Promotions are scoped to a client and apply across all of that client's
 * storefronts. A promotion adds one or more free gift line items to the cart
 * automatically when its conditions are met (a trigger product is present
 * and/or the cart subtotal reaches a minimum). Enforcement happens server-side
 * during cart mutations; these types cover only the admin configuration surface.
 */
/** Line attribute marking a cart line as an automatically managed free gift. */
export const MANAGED_GIFT_ATTRIBUTE = '_storefronts_managed_gift';
